<template>
    <div class="tab-pane fade" v-bind:class="{ 'show active': this.$props.tabs.newspapers }">
        
        <g-vue-table
        :apiIndexUrl="'/api/publishers/'+obj.id+'/editorials'"
        sortBy="first_name"
        sortDirection="asc"
        :columns="columns"
        :obj="obj"
        ></g-vue-table>

    </div>
</template>

<script>
export default {
    name : 'EditorialsList',
    props : [ 'tabs', 'obj' ],
    methods : {
        redirect(url) {
            if ( this.$route.path !== url )
                this.$router.push({ path: url })
        }
    },
    data(){
        return {
            columns : [{
                title: '#',
                name: 'id',
                sortField: 'id',
                titleClass: 'text-right medium-cell',
                dataClass: 'text-right medium-cell clickable',
                visible : true,
                cellClicked : function(t, data) {
                    window.open('/#/editorials/'+data.id)
                },
            },{
                title : this.transUC('name'),
                name: 'companyname',
                sortField: 'companyname',
                dataClass: 'clickable',
                visible : true,
                cellClicked : function(t, data) {
                    window.open('/#/editorials/'+data.id)
                },
            },{
                title : this.transUC('city'),
                name : 'city',
                sortField: 'city',
                visible : true
            },{
                title : this.transUC('publisher'),
                name: '_publisher',
                sortField: '_publisher',
                dataClass: 'clickable',
                visible : true,
                callback : function(data) {
                    if (data === null)
                        return null
                    data = (new String(data)).split('||')
                    var result = [];
                    for (var i=0;i<data.length;i++) {
                        var pattern = /\[(.*?)\]/g;
                        var match;
                        while ((match = pattern.exec(data[i])) != null) {
                            // id = match[1]
                            var str = '<a href="/#/publishers/'+match[1]+'" target="_blank">'+data[i].replace(match[0], '')+'</a>'
                            result.push( str )
                        }
                    }
                    return result.join(' + ')
                }
            },{
                title : this.transUC('periodicity'),
                name : '_periodicity',
                sortField: '_periodicity',
                callback : function(data) {
                    if (data === null)
                        return null
                    data = (new String(data)).split('||')
                    var result = [];
                    for (var i=0;i<data.length;i++) {
                        var pattern = /\[(.*?)\]/g;
                        var match;
                        while ((match = pattern.exec(data[i])) != null) {
                            // id = match[1]
                            var str = data[i].replace(match[0], '')
                            result.push( str )
                        }
                    }
                    return result.join(' + ')
                },
                visible : true
            },{
                title : this.transUC('category'),
                name : '_categories',
                sortField: '_categories',
                callback : function(data) {
                    if (data === null)
                        return null
                    data = (new String(data)).split('||')
                    var result = [];
                    for (var i=0;i<data.length;i++) {
                        var pattern = /\[(.*?)\]/g;
                        var match;
                        while ((match = pattern.exec(data[i])) != null) {
                            // id = match[1]
                            var str = data[i].replace(match[0], '')
                            result.push( str )
                        }
                    }
                    return result.join(' + ')
                },
                visible : true
            },{
                title : this.transUC('genre'),
                name : '_genres',
                sortField: '_genres',
                callback : function(data) {
                    if (data === null)
                        return null
                    data = (new String(data)).split('||')
                    var result = [];
                    for (var i=0;i<data.length;i++) {
                        var pattern = /\[(.*?)\]/g;
                        var match;
                        while ((match = pattern.exec(data[i])) != null) {
                            // id = match[1]
                            var str = data[i].replace(match[0], '')
                            result.push( str )
                        }
                    }
                    return result.join(' + ')
                },
                visible : true
            },{
                title : this.transUC('journ'),
                name: '_journalists_count',
                sortField: '_journalists_count',
                titleClass: 'text-center short-cell',
                dataClass: 'text-center short-cell',
                visible : true,
                callback(data) {
                    return data !== 0 ? data : ''
                }
            },{
                title : this.transUC('updated'),
                name: 'updated_at',
                sortField: 'updated_at',
                titleClass: 'text-center updated-at-cell',
                dataClass: 'text-right updated-at-cell',
                visible : true
            }],
        }
    }
}
</script>